import React, { useState } from "react";

import { useLocation } from "react-router-dom";
import clsx from "clsx";

import AppRoutes from "./routes/App.routes";
import useStyles from "./App.styles.js";

// ✅ Shown only in development
function CredentialModal({ open, onSubmit }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "2em",
          borderRadius: "8px",
          minWidth: "320px",
          boxShadow: "0 2px 10px #444"
        }}
      >
        <h2 style={{ color: "black" }}>Login Required</h2>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{ width: "100%", margin: "8px 0", padding: "8px", color: "black" }}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: "100%", margin: "8px 0", padding: "8px", color: "black" }}
        />

        <div style={{ textAlign: "center" , color: "white", backgroundColor: "black", width: "50px"}}>
          <button onClick={() => onSubmit(username, password)}>OK</button>
        </div>
      </div>
    </div>
  );
}

function AppWrapper() {
  const classes = useStyles();

    const location = useLocation();
  const isSports = location.pathname.includes("/sports");
  // ✅ Production-safe logic
  const isDev = process.env.REACT_APP_SERVER_URL?.includes("dev");

  const [modalOpen, setModalOpen] = useState(isDev);
  const [authenticated, setAuthenticated] = useState(!isDev);

  const handleLogin = (username, password) => {
    if (username === "devUser" && password === "devUser@123") {
      setAuthenticated(true);
      setModalOpen(false);
    } else {
      alert("Username and Password required!");
    }
  };

  return (
      <div
        className={clsx(
          classes.mainContainer,
          isSports && classes.sportsContainer
        )}
      >
      {isDev && <CredentialModal open={modalOpen} onSubmit={handleLogin} />}
      {authenticated && <AppRoutes />}
    </div>
  );
}

export default AppWrapper;
